'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$24(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_GroupsView$$anon$24 as $c_Lpresto_GroupsView$$anon$24 };
$p = $c_Lpresto_GroupsView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$24;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$24() {
}
export { $h_Lpresto_GroupsView$$anon$24 as $h_Lpresto_GroupsView$$anon$24 };
$h_Lpresto_GroupsView$$anon$24.prototype = $p;
$p.b6 = (function(_$21) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$21, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$22) => _$22.ja)), $j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().SB());
});
var $d_Lpresto_GroupsView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$24, "presto.GroupsView$$anon$24", ({
  Kb: 1,
  G: 1
}));
export { $d_Lpresto_GroupsView$$anon$24 as $d_Lpresto_GroupsView$$anon$24 };
//# sourceMappingURL=presto.-Groups-View$$anon$24.js.map
